import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.get(`/auth/verify?token=${encodeURIComponent(token)}`)
      .then(async () => { setState("ok"); if (user) await refreshUser().catch(() => {}); })
      .catch(() => setState("error"));
  }, []); // eslint-disable-line

  return (
    <div className="App bg-[#F4F7FA] min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-24 text-center" data-testid="verify-email-page">
        {state === "loading" && <p className="text-slate-400">Verifying…</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-mint mx-auto" />
            <h1 className="mt-4 font-heading font-extrabold text-3xl text-navy">Email verified</h1>
            <p className="mt-2 text-slate-600">Thanks — your email address is now confirmed.</p>
            <button data-testid="verify-continue" onClick={() => navigate("/")} className="mt-6 bg-mint text-white font-semibold px-6 py-3 rounded-xl hover:bg-mint-dark transition-colors">Continue</button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 className="mt-4 font-heading font-extrabold text-3xl text-navy">Link invalid or expired</h1>
            <p className="mt-2 text-slate-600">Please request a new verification email from your dashboard.</p>
          </>
        )}
      </div>
    </div>
  );
}
